"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnChGbp = exports.EnChUsd = exports.EnChEur = exports.EnChChf = exports.ItChGbp = exports.ItChUsd = exports.ItChEur = exports.ItChChf = exports.FrChGbp = exports.FrChUsd = exports.FrChEur = exports.FrChChf = exports.DeChGbp = exports.DeChUsd = exports.DeChEur = exports.DeChChf = void 0;
class DeChChf {
    constructor() {
        this.locale = "de-ch";
        this.dateFormat = {
            short: "dd.MM.yyyy",
            medium: "dd. MMMM yyyy",
            long: "dddd, d. MMMM yyyy",
        };
        this.currencyFormat = {
            code: "CHF",
            symbol: "CHF",
            decimalSeparator: ".",
            groupSeparator: "'",
            positivePattern: "C n",
            negativePattern: "C -n"
        };
    }
}
exports.DeChChf = DeChChf;
class DeChEur {
    constructor() {
        this.locale = "de-ch";
        this.dateFormat = {
            short: "dd.MM.yyyy",
            medium: "dd. MMMM yyyy",
            long: "dddd, d. MMMM yyyy",
        };
        this.currencyFormat = {
            code: "EUR",
            symbol: "€",
            decimalSeparator: ".",
            groupSeparator: ",",
            positivePattern: "C n",
            negativePattern: "C -n"
        };
    }
}
exports.DeChEur = DeChEur;
class DeChUsd {
    constructor() {
        this.locale = "de-ch";
        this.dateFormat = {
            short: "dd.MM.yyyy",
            medium: "dd. MMMM yyyy",
            long: "dddd, d. MMMM yyyy",
        };
        this.currencyFormat = {
            code: "USD",
            symbol: "$",
            decimalSeparator: ".",
            groupSeparator: ",",
            positivePattern: "C n",
            negativePattern: "C -n"
        };
    }
}
exports.DeChUsd = DeChUsd;
class DeChGbp {
    constructor() {
        this.locale = "de-ch";
        this.dateFormat = {
            short: "dd.MM.yyyy",
            medium: "MMMM dd, yyyy",
            long: "dddd, d. MMMM yyyy",
        };
        this.currencyFormat = {
            code: "GBP",
            symbol: "£",
            decimalSeparator: ".",
            groupSeparator: "’",
            positivePattern: "C n",
            negativePattern: "C-n"
        };
    }
}
exports.DeChGbp = DeChGbp;
class FrChChf {
    constructor() {
        this.locale = "fr-ch";
        this.dateFormat = {
            short: "dd.MM.yyyy",
            medium: "dd. MMMM yyyy",
            long: "dddd, d. MMMM yyyy",
        };
        this.currencyFormat = {
            code: "CHF",
            symbol: "CHF",
            decimalSeparator: ".",
            groupSeparator: "'",
            positivePattern: "C n",
            negativePattern: "C -n"
        };
    }
}
exports.FrChChf = FrChChf;
class FrChEur {
    constructor() {
        this.locale = "fr-ch";
        this.dateFormat = {
            short: "dd.MM.yyyy",
            medium: "dd. MMMM yyyy",
            long: "dddd, d. MMMM yyyy",
        };
        this.currencyFormat = {
            code: "EUR",
            symbol: "€",
            decimalSeparator: ".",
            groupSeparator: ",",
            positivePattern: "C n",
            negativePattern: "C -n"
        };
    }
}
exports.FrChEur = FrChEur;
class FrChUsd {
    constructor() {
        this.locale = "fr-ch";
        this.dateFormat = {
            short: "dd.MM.yyyy",
            medium: "dd. MMMM yyyy",
            long: "dddd, d. MMMM yyyy",
        };
        this.currencyFormat = {
            code: "USD",
            symbol: "$",
            decimalSeparator: ".",
            groupSeparator: ",",
            positivePattern: "C n",
            negativePattern: "C -n"
        };
    }
}
exports.FrChUsd = FrChUsd;
class FrChGbp {
    constructor() {
        this.locale = "fr-ch";
        this.dateFormat = {
            short: "dd.MM.yyyy",
            medium: "MMMM dd, yyyy",
            long: "dddd, d MMMM yyyy",
        };
        this.currencyFormat = {
            code: "GBP",
            symbol: "£",
            decimalSeparator: ".",
            groupSeparator: " ",
            positivePattern: "n C",
            negativePattern: "-n C"
        };
    }
}
exports.FrChGbp = FrChGbp;
class ItChChf {
    constructor() {
        this.locale = "it-ch";
        this.dateFormat = {
            short: "dd.MM.yyyy",
            medium: "dd. MMMM yyyy",
            long: "dddd, d. MMMM yyyy",
        };
        this.currencyFormat = {
            code: "CHF",
            symbol: "CHF",
            decimalSeparator: ".",
            groupSeparator: "'",
            positivePattern: "C n",
            negativePattern: "C -n"
        };
    }
}
exports.ItChChf = ItChChf;
class ItChEur {
    constructor() {
        this.locale = "it-ch";
        this.dateFormat = {
            short: "dd.MM.yyyy",
            medium: "dd. MMMM yyyy",
            long: "dddd, d. MMMM yyyy",
        };
        this.currencyFormat = {
            code: "EUR",
            symbol: "€",
            decimalSeparator: ".",
            groupSeparator: ",",
            positivePattern: "C n",
            negativePattern: "C -n"
        };
    }
}
exports.ItChEur = ItChEur;
class ItChUsd {
    constructor() {
        this.locale = "it-ch";
        this.dateFormat = {
            short: "dd.MM.yyyy",
            medium: "dd. MMMM yyyy",
            long: "dddd, d. MMMM yyyy",
        };
        this.currencyFormat = {
            code: "USD",
            symbol: "$",
            decimalSeparator: ".",
            groupSeparator: ",",
            positivePattern: "C n",
            negativePattern: "C -n"
        };
    }
}
exports.ItChUsd = ItChUsd;
class ItChGbp {
    constructor() {
        this.locale = "it-ch";
        this.dateFormat = {
            short: "dd.MM.yyyy",
            medium: "MMMM dd, yyyy",
            long: "dddd, d MMMM yyyy",
        };
        this.currencyFormat = {
            code: "GBP",
            symbol: "£",
            decimalSeparator: ".",
            groupSeparator: "’",
            positivePattern: "C n",
            negativePattern: "C-n"
        };
    }
}
exports.ItChGbp = ItChGbp;
class EnChChf {
    constructor() {
        this.locale = "en-ch";
        this.dateFormat = {
            short: "dd.MM.yyyy",
            medium: "dd. MMMM yyyy",
            long: "dddd, d. MMMM yyyy",
        };
        this.currencyFormat = {
            code: "CHF",
            symbol: "CHF",
            decimalSeparator: ".",
            groupSeparator: "'",
            positivePattern: "C n",
            negativePattern: "C -n"
        };
    }
}
exports.EnChChf = EnChChf;
class EnChEur {
    constructor() {
        this.locale = "en-ch";
        this.dateFormat = {
            short: "dd.MM.yyyy",
            medium: "dd. MMMM yyyy",
            long: "dddd, d. MMMM yyyy",
        };
        this.currencyFormat = {
            code: "EUR",
            symbol: "€",
            decimalSeparator: ".",
            groupSeparator: ",",
            positivePattern: "C n",
            negativePattern: "C -n"
        };
    }
}
exports.EnChEur = EnChEur;
class EnChUsd {
    constructor() {
        this.locale = "en-ch";
        this.dateFormat = {
            short: "dd.MM.yyyy",
            medium: "dd. MMMM yyyy",
            long: "dddd, d. MMMM yyyy",
        };
        this.currencyFormat = {
            code: "USD",
            symbol: "$",
            decimalSeparator: ".",
            groupSeparator: ",",
            positivePattern: "C n",
            negativePattern: "C -n"
        };
    }
}
exports.EnChUsd = EnChUsd;
class EnChGbp {
    constructor() {
        this.locale = "en-ch";
        this.dateFormat = {
            short: "dd.MM.yyyy",
            medium: "MMMM dd, yyyy",
            long: "dddd, d. MMMM yyyy",
        };
        this.currencyFormat = {
            code: "GBP",
            symbol: "£",
            decimalSeparator: ".",
            groupSeparator: "’",
            positivePattern: "C n",
            negativePattern: "C-n"
        };
    }
}
exports.EnChGbp = EnChGbp;
